/* eslint-disable jsx-a11y/anchor-has-content,no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import Common from '../shared/common';
import { FormattedMessage, injectIntl } from "react-intl";
import * as paymentCertificateCrud from '../crud/paymentCertificate.crud';
import { withRouter } from '../shared/hoc/withRouter';
import SystemHelper from "../shared/systemHelper";

const spanStyleViewRegister = {
  whiteSpace: 'normal',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  paddingBottom: 0,
  //fontWeight: 400
};

class ContractPayments extends React.Component {
  state = {
    appliedAmount: 0,
    certifiedAmount: 0,
    lastCommunicatedPaymentCertificateId: null,
    lastCommunicatedPaymentApplicationId: null
  }
  componentDidMount() {
    this.setNewState(this.props.dashboardCurrencyCode);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dashboardCurrencyCode !== this.props.dashboardCurrencyCode) {
      this.setNewState(this.props.dashboardCurrencyCode)
    }
  }
  setNewState = async (currencyCode) => {
    let appliedAmount = 0, certifiedAmount = 0, lastCommunicatedPaymentCertificateId = 0, lastCommunicatedPaymentApplicationId = 0;
    if (this.props.contract.contractid > 0) {
      const { data: resp } = await paymentCertificateCrud.getLastPaymentAmounts(this.props.contract.contractid, ["Certificate", "Application"], [currencyCode], '');
      if (resp && resp.length > 0) {
        appliedAmount = resp.find(x => x.paymenttype === 'Application')?.amount || 0;
        certifiedAmount = resp.find(x => x.paymenttype === 'Certificate')?.amount || 0;
        lastCommunicatedPaymentCertificateId = resp.find(x => x.paymenttype === 'Certificate')?.lastcommunicatedpaymentcertificateid;
        lastCommunicatedPaymentApplicationId = resp.find(x => x.paymenttype === 'Application')?.lastcommunicatedpaymentapplicationid;
      }
    }


    this.setState({ appliedAmount, certifiedAmount, lastCommunicatedPaymentCertificateId, lastCommunicatedPaymentApplicationId })
  }
  getUserDetails = (title, price) => {

    return (
      <div className="contractPayments__item ">
        <div className="contractPayments__info ">
          <p className="contractPayments__text ">
            {title}<br />
          </p>
          <span className="contractPayments__price" >{Common.FormatCurrencyNum(price, this.props.currencyCode)}</span>
        </div>
        {/* <span className="contractPayments__desc" style={{ color: '#74788d', fontWeight: 600 }}>{user.company}</span> */}
      </div>
    );
  }
  render() {
    if (this.props.globalResources && (this.props.globalResources.WF_20_TITLE || this.props.globalResources.WF_21_TITLE)) {
      return (
          <div className="contractPayments">
            <div className="contractPayments__header">
              <h3 className="contractPayments__title">
                 {this.props.title ? this.props.title :this.props.globalResources.WFG_108_TITLE}
              </h3>
            </div>
            {
              this.props.globalResources.WF_21_TITLE && (
                <div className="contractPayments__item ">
                  <div className="contractPayments__info ">
                    <p className="contractPayments__text ">
                      {this.props.globalResources.WF_21_TITLE}<br />
                    </p>
                    {
                      this.state.lastCommunicatedPaymentApplicationId > 0 ? (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <span className="contractPayments__price">
                            {Common.FormatCurrencyNum(this.state.appliedAmount, this.props.dashboardCurrencyCode)}
                          </span>
                          <div className="kt-contractPayments__info" style={{ textAlign: 'right', flexGrow: 1 }}>
                            <span className="kt-widget12__desc" style={spanStyleViewRegister}>
                              <a onClick={() => {
                                this.props.navigate(`/contract/${this.props.contract.contractid}/payments/supplier/${this.state.lastCommunicatedPaymentApplicationId}`);
                              }}
                                style={{ textDecoration: 'underline', fontSize: '1.1rem', paddingTop: '0.5rem' }}
                              >
                                <FormattedMessage id="CONTRACT.DASHBOARD.VIEW" />
                              </a>
                            </span>
                          </div>
                        </div>
                      ) : (
                        <span className="contractPayments__price" >
                          {Common.FormatCurrencyNum(this.state.appliedAmount, this.props.dashboardCurrencyCode)}
                        </span>
                      )
                    }
                  </div>
                </div>
              )
            }
            {this.props.globalResources.WF_20_TITLE && (
              <div className="contractPayments__item ">
                <div className="contractPayments__info ">
                  <p className="contractPayments__text ">
                    {this.props.globalResources.WF_20_TITLE}<br />
                  </p>
                  {
                    this.state.lastCommunicatedPaymentCertificateId > 0 ? (
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <span className="contractPayments__price">
                          {Common.FormatCurrencyNum(this.state.certifiedAmount, this.props.dashboardCurrencyCode)}
                        </span>
                        <div className="kt-contractPayments__info" style={{ textAlign: 'right', flexGrow: 1 }}>
                          <span className="kt-widget12__desc" style={spanStyleViewRegister}>
                            <a onClick={() => {
                              this.props.navigate(`/contract/${this.props.contract.contractid}/payments/pm/${this.state.lastCommunicatedPaymentCertificateId}`);
                            }}
                              style={{ textDecoration: 'underline', fontSize: '1.1rem', paddingTop: '0.5rem' }}
                            >
                              <FormattedMessage id="CONTRACT.DASHBOARD.VIEW" />
                            </a>
                          </span>
                        </div>
                      </div>
                    ) : (
                      <span className="contractPayments__price">
                        {Common.FormatCurrencyNum(this.state.certifiedAmount, this.props.dashboardCurrencyCode)}
                      </span>
                    )
                  }
                </div>
              </div>
            )
            }
          </div>
      );
    }
    else {

      return (
        <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span style={{ fontFamily: SystemHelper.getThemeTextFont(), fontSize: '1.1rem', color: '#74788d', textAlign: 'center' }}><FormattedMessage id="CONTRACT.DASHBOARD.PAYMENTS_NOT AVAILABLE" /></span>
        </div>
      )
    }

  }
}


export default injectIntl(withRouter(ContractPayments));
